import { h, Fragment } from "preact";
import { Trans } from "@lingui/react/macro";
import Session from "../../../jamibet/utils/session";
import * as I from "../../../jamibet/utils/icons";
import BetsHistoryPage from "./menu-bets-history";
import ProfilePage from "../../../jamibet/desktop-components/user/menu-profile";
import TransactionsHistoryPage from "../../../jamibet/desktop-components/user/menu-transaction-history";
import CashoutPage from "../../../jamibet/desktop-components/user/menu-cashout";
import DashboardPage from "../../../jamibet/desktop-components/user/menu-dashboard";
import PaymentGatewayPage from "./menu-payment-gateway";
import ManagerReport from "../../../jamibet/desktop-components/user/manager-report";
import { BonusStatusPage } from "../../../jamibet/desktop-components/user/menu-bonus-status";
import { VouchersPage } from "../../../jamibet/desktop-components/user/menu-vouchers";
import { Overlay } from "../../../jamibet/desktop-components/user/menu-popup";

import { useHeadlessComponent } from "../../../../utils/component-converter";
import JamibetMenuPopup from "../../../jamibet/desktop-components/user/menu-popup";

export default function MenuPopup() {
    const api = useHeadlessComponent(JamibetMenuPopup, {});
    const { state } = api;

    if (!state.visible || !Session.isActive())
        return null;

    return <Overlay onClick={e => api.setState({ visible: false })}>
        <div id="user-menu-content" class="user-menu-content bg-white w-full max-w-6xl h-full max-h-[calc(100vh-170px)] flex flex-col" ref={e => api.root = e}>
            {api.drawHeader()}
            <section class="h-full overflow-auto">
                {state.currentpage === 'transactions' && <TransactionsHistoryPage />}
                {state.currentpage === 'bets' && <BetsHistoryPage />}
                {state.currentpage === 'cashouts' && <CashoutPage />}
                {state.currentpage === 'messages' && <ComingSoonSvg />}
                {state.currentpage === 'profile' && <ProfilePage />}
                {state.currentpage === 'dashboard' && <DashboardPage />}
                {state.currentpage === 'reports' && <ManagerReport usetree={false} />}
                {state.currentpage === 'payment-gateway' && <PaymentGatewayPage />}
                {state.currentpage === 'vouchers' && <VouchersPage />}
                {state.currentpage === 'bonus-status' && <BonusStatusPage />}
            </section>
        </div>
    </Overlay>;
}

const ComingSoonSvg = () => null
